module.exports = __webpack_public_path__ + "img/index04.d1e2f555.svg";